<template>
  <div
    v-b-popover.hover.top="{
      content: popoverContent,
    }"
  >
    <button class="estimate-earning-button">
      <img
        class="coin-icon"
        :src="require('images/views/job/coin.png')"
        alt="baht"
      />
      <p>{{ incentive }}</p>
    </button>
  </div>
</template>

<script>
import { VBPopover } from 'bootstrap-vue'

export default {
  name: 'CommissionEarning',

  directives: {
    'b-popover': VBPopover,
  },

  props: {
    incentive: {
      type: String,
      default: () => '0',
    },
  },

  data() {
    return {
      popoverContent: "Estimated earning you'll receive (in THB)!",
    }
  },
}
</script>

<style scoped lang="scss">
@import 'stylesheets/global';

.estimate-earning-button {
  background-color: #fff;
  border: 0;
  border-radius: 15px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  display: flex;
  margin-left: 15px;
  padding: 3.5px;

  @include sp {
    margin: 6px 0 3px 0;
    padding: 2px;
  }

  p {
    align-items: center;
    color: #787a7a;
    display: flex;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 500;
    margin: 1px 5px 0 3px;
  }

  i.add {
    font-size: 0.65rem;
    font-weight: 200;
    line-height: 0.9;
    margin-left: 2px;
  }

  img.coin-icon {
    height: 20px;
    margin-left: 5px;
    margin-right: 3px;
    width: 20px;
  }
}

.estimate-earning-button:hover {
  background-color: #fff;
}

@media only screen and (max-width: 991px) {
  .estimate-earning-button p {
    font-size: 12px;
    margin-top: 2px;
  }
}
</style>
